module.exports = __webpack_public_path__ + "static/media/home_introduce_1.890afdc3.jpg";